import { render, staticRenderFns } from "./ChartVentas.vue?vue&type=template&id=0a6a67b4&"
import script from "./ChartVentas.vue?vue&type=script&lang=js&"
export * from "./ChartVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports